import { useMemo } from 'react';

import { workflowDataState, useSubscribableState, getSubscribableStateValue } from '../../subscribable-state';

export const getWorkflowState = (workflow) => {
  return getSubscribableStateValue(workflowDataState().key)[workflow];
};

export const useWorkflowData = (workflowData) => {
  // oxlint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setWorkflowDataObject] = useSubscribableState(workflowDataState(workflowData));
  return useMemo(
    () => ({
      setWorkflowDataObject,
    }),
    [setWorkflowDataObject],
  );
};
